const NPS_APP = process.env.VUE_APP_NPS_APP || '';
const NPS_URL = process.env.VUE_APP_NPS_URL || '';
export default {
    NPS_APP,
    NPS_URL
}